export { default } from "./shopLocation.api";
export * from "./shopLocation.api.types";
